module.exports = __webpack_public_path__ + "static/img/v5.db93723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v5.jpg
// module id = oDk0
// module chunks = 1